import { Card, Text } from '@chakra-ui/react'
import { useTranslation } from '../../i18n'

function formatValue(value, format, t) {
  if (value === null || value === undefined) return '—'
  if (format === 'percent') {
    return `${Math.round(Number(value) * 100)}%`
  }
  if (format === 'seconds') {
    return t('analytics.secondsUnit', { value: Number(value).toFixed(1) })
  }
  return String(value)
}

export function MetricCard({ label, value, hint, format }) {
  const { t } = useTranslation()
  const display = formatValue(value, format, t)
  return (
    <Card.Root bg="var(--mc-bg-surface)" border="1px solid" borderColor="var(--mc-border)">
      <Card.Body gap={1}>
        <Text fontSize="xs" color="fg.muted" textTransform="uppercase" letterSpacing="wide">
          {label}
        </Text>
        <Text fontSize="3xl" fontWeight="bold" color="var(--mc-text)" lineHeight="1.1">
          {display}
        </Text>
        {hint && (
          <Text fontSize="xs" color="fg.subtle">
            {hint}
          </Text>
        )}
      </Card.Body>
    </Card.Root>
  )
}
